import { faClose } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useRef } from "react";

const CustomModal = ({
  open,
  title,
  children,
  className,
  bgOpacity,
  closeWhenClickedOutside,
  handleCloseModal,
}) => {
  const modalRef = useRef(null);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        handleCloseModal();
      }
    };

    const handleBodyScroll = () => {
      document.body.style.overflow = open ? "hidden" : "";
    };

    if (open && closeWhenClickedOutside) {
      document.addEventListener("mousedown", handleOutsideClick);
      handleBodyScroll();
    }

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
      document.body.style.overflow = "";
    };
  }, [open]);

  if (!open) return null;

  return (
    <div
      className={`fixed inset-0 flex items-center justify-center ${
        bgOpacity || "bg-black/60"
      } z-[999999] `}
    >
      <div
        ref={modalRef}
        className={`!bg-black rounded-lg shadow-lg max-w-lg w-[90%] mx-2 !p-4 relative ${
          className || ""
        }`}
      >
        <button
          onClick={handleCloseModal}
          className="absolute top-2 right-2 text-white hover:text-gray-700"
        >
          <FontAwesomeIcon icon={faClose} className="text-[20px] mt-2 mr-2" />
        </button>
        {title && (
          <h3 className="font-semibold leading-6 text-2xl mb-4">{title}</h3>
        )}
        {children}
      </div>
    </div>
  );
};

export default CustomModal;
